import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { BillingActionsDialog } from "./BillingActionsDialog";

const money = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} $`;

// Accueil : familles qui paient encore 2 fois par mois → fusion en un clic (aperçu Stripe avant confirmation).
export function PayerDuplicatesAlert() {
  const [groups, setGroups] = useState(null);
  const [dlg, setDlg] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("kz-payer-dup-hidden") === "1");
  const navigate = useNavigate();

  const load = () => api.get("/billing/payer-groups").then((r) => setGroups(r.data.groups.filter((g) => g.can_merge))).catch(() => setGroups([]));
  useEffect(() => { load(); }, []);

  if (hidden || !groups || groups.length === 0) return null;
  const shown = groups.slice(0, 4);

  return (
    <div className="mx-6 md:mx-8 lg:mx-10 mt-6 rounded-xl border border-amber-500/40 bg-amber-500/[0.06] p-4" data-testid="payer-duplicates-alert">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.2em] text-amber-300 font-semibold">Facturation · doublons payeur</p>
          <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="payer-duplicates-title">
            {groups.length} famille{groups.length > 1 ? "s" : ""} paie{groups.length > 1 ? "nt" : ""} encore {groups.length > 1 ? "plusieurs" : "2"} fois par mois
          </h3>
          <p className="text-xs text-zinc-400 mt-0.5">Un même payeur, plusieurs abonnements Stripe. Fusionne-les : 1 seule facture, 1 seul reçu famille, jamais de double charge.</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button onClick={() => navigate("/app/membres-paiements")} className="text-xs text-amber-300 hover:underline" data-testid="payer-duplicates-see-all">Tout voir →</button>
          <button onClick={() => { sessionStorage.setItem("kz-payer-dup-hidden", "1"); setHidden(true); }} className="text-zinc-500 hover:text-zinc-300 text-sm" title="Masquer pour cette session" data-testid="payer-duplicates-hide">✕</button>
        </div>
      </div>
      <ul className="mt-3 grid md:grid-cols-2 gap-2">
        {shown.map((g) => (
          <li key={g.payer_email} className="flex items-center justify-between gap-3 rounded-lg bg-zinc-900/70 border border-zinc-800 px-3 py-2" data-testid={`payer-dup-${g.payer_email}`}>
            <div className="min-w-0">
              <div className="text-sm text-zinc-100 truncate">{g.contracts.map((c) => c.full_name).join(" + ")}</div>
              <div className="text-[11px] text-zinc-500 truncate">{g.payer_email} · {g.distinct_subscriptions} abonnements · {money(g.monthly_total)}/mois</div>
            </div>
            <button onClick={() => setDlg({ contractIds: g.contracts.map((c) => c.id), payerEmail: g.payer_email })}
              className="shrink-0 px-3 py-1.5 rounded-lg bg-[#7c3aed] hover:bg-[#6d28d9] text-white text-xs font-semibold" data-testid={`payer-dup-merge-${g.payer_email}`}>⛓ Fusionner</button>
          </li>
        ))}
      </ul>
      {groups.length > shown.length && <p className="text-[11px] text-zinc-500 mt-2">+ {groups.length - shown.length} autre(s) dans Membres & paiements → Regrouper</p>}
      <BillingActionsDialog open={!!dlg} onClose={() => setDlg(null)} action="merge" contractIds={dlg?.contractIds || []} payerEmail={dlg?.payerEmail} onDone={load} />
    </div>
  );
}
